import React, { useEffect, useState } from "react";
import AddBaseModal from "../../../../../components/add-base-modal/AddBaseModal";
import { showMessage, useApi } from "../../../../../services/helpers";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

const stripePromise = loadStripe("pk_test_your_publishable_key");

const PaymentModal = ({ open, onClose, requestedOrder, projectId }) => {
  const api = useApi();
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);

  // determine if any product in requestedOrder has stripe enabled
  const isStripeEnabled = React.useMemo(() => {
    if (!requestedOrder?.sections || requestedOrder.sections.length === 0) return false;
    return requestedOrder.sections.some(section =>
      section?.lines && section.lines.some(line => line?.product?.stripe_enabled === true)
    );
  }, [requestedOrder]);

  console.log("requestedOrder FULL:", JSON.stringify(requestedOrder, null, 2));

  console.log("PaymentModal props:", { open, requestedOrder });
  console.log("Rendering Elements?", {
    loading,
    clientSecret,
    stripePromise,
  });

  useEffect(() => {
    if (open) {
      createPaymentIntent();
    }
  }, [open]);

  const createPaymentIntent = async () => {
    if (!requestedOrder?.id) return;

    setLoading(true);

    try {
      const result = await api.createPaymentIntent(
        projectId,
        requestedOrder,
        requestedOrder.id
      );

      console.log("Stripe API FULL result:", result);

      if (result.kind === "ok") {
        console.log("Client Secret from backend:", result.data);
        setClientSecret(result.data.client_secret);
      } else {
        const d = result.errors ?? result.data;
        const msg = typeof d === 'string' ? d
          : Array.isArray(d) ? d[0]
          : d?.detail || d?.non_field_errors?.[0]
          || (d && typeof d === 'object' ? Object.values(d).flat()[0] : null)
          || "Payment setup failed. Please try again.";
        showMessage(msg, 'warning');
        onClose();
      }
    } catch (error) {
      console.log("Payment intent error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AddBaseModal
      open={open}
      handleClose={onClose}
      showActions={false}
      modalContainer={{ width: 650 }}
    >
      <MDBox p={3} minHeight={300}>
        {loading && <MDTypography>Preparing secure payment...</MDTypography>}

        {!loading && !isStripeEnabled && (
          <MDTypography color="error">
            Payment is not available because no products support Stripe.
          </MDTypography>
        )}

        {!loading && clientSecret && isStripeEnabled && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm clientSecret={clientSecret} onSuccess={onClose} />
          </Elements>
        )}
      </MDBox>
    </AddBaseModal>
  );
};

export default PaymentModal;
